import React from 'react';
import {StaticImage} from 'gatsby-plugin-image';
import {sectionLayoutChildAnimation,} from '../../utils/animations';
import {motion} from 'framer-motion';
import SectionLayout from '../../layouts/section-layout';

export default function DetailCard({
                                       idx,
                                       title,
                                       image,
                                       body,
                                       cardBackground,
                                   }) {
    return (
        <SectionLayout>
            <motion.div
                variants={sectionLayoutChildAnimation}
                className={`flex justify-between flex-col-reverse  mb-4  w-full p-4 rounded-lg  mx-auto
               ${idx ? ' md:flex-row-reverse ' : 'md:flex-row '}
               ${cardBackground ? 'bg-white  shadow-lg' : ''}
               `}
            >
                <div className="p-3 lg:p-6  flex-1 order-1">
                    <h5 className="mb-3 trext-center md:text-left text-2xl font-semibold leading-none tracking-tighter text-gray-700">
                        {title}
                    </h5>

                    {(body || []).map((b, index) =>
                        <div key={index} className="mx-auto text-left text-sm mt-4 font-medium  leading-normal  text-gray-700 "
                           dangerouslySetInnerHTML={{__html: b}}>
                        </div>
                    )}
                </div>

                {image &&
                    <div className={`flex-1 order-0`}>
                        {image === 'app_1' && (
                            <StaticImage
                                className={`rounded shadow-lg min-h-16 h-80 w-40 m-3 `}
                                src={`../../assets/images/app_1.png`}
                                alt="a map photo"
                            />
                        )}
                        {image === 'scenery_1' && (
                            <StaticImage
                                className={`rounded shadow-lg min-h-16 h-60 m-3 `}
                                src={`../../assets/images/scenery_1.jpg`}
                                alt="a map photo"
                            />
                        )}
                        {image === 'scenery_2' && (
                            <StaticImage
                                className={`rounded shadow-lg min-h-16 m-3 `}
                                src={`../../assets/images/scenery_2.jpg`}
                                alt="a map photo"
                            />
                        )}
                        {image === 'scenery_3' && (
                            <StaticImage
                                className={`rounded shadow-lg min-h-16 h-60 m-3 `}
                                src={`../../assets/images/scenery_3.jpg`}
                                alt="a map photo"
                            />
                        )}
                    </div>
                }
            </motion.div>
        </SectionLayout>
    );
}
